

$(document).ready(function () {

    console.log('loaded ok');

    $(".shortcut__item-showmore .shortcut__item-wrapper .btn").on("click", function (e) {
        var $element = $(this);
        $element.parent().parent().parent().find(".shortcut__item").each(function() {
            if (!$(this).hasClass("shortcut__item-showmore")) {
                $(this).toggleClass("shortcut__item-active");
            }
        });

        if ($element.attr("data-istoggled") == "2") {
            console.log($element.attr("data-istoggled"));
            $element.html($element.data("untoggletxt"));
            $element.attr("data-istoggled", "1"); 
        }

        else if ($element.attr("data-istoggled") == "1") {
            console.log($element.attr("data-istoggled"));
            $element.html($element.data("toggletxt"));
            $element.attr("data-istoggled", "2");
        }
    });

});